module.exports = __webpack_public_path__ + "media/books/Mosaics-608d4d15.jpg";